// extracted by mini-css-extract-plugin
export default {"addToCartControl":"k1-z","giftCard":"l1-z","btnContainer":"m1-z","cartButton":"n1-z","disabled":"o1-z"};